import React from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { FeaturedHubScreen } from '@/feature/lobby-sbk/screens/FeaturedHub';
import { SbkLobbyScreen } from '@/feature/lobby-sbk/screens/SbkLobby';
import { PromoHubStack } from '@/feature/promohub/PromohubStack';

import { SweepsLobbyStackParamList } from './types';

const Stack = createNativeStackNavigator<SweepsLobbyStackParamList>();

export const LobbyStack = () => {
    return (
        <Stack.Navigator screenOptions={{ headerShown: false }}>
            <Stack.Screen name="SweepsLobbyScreen" component={SbkLobbyScreen} />
            <Stack.Screen name="FeaturedHub" component={FeaturedHubScreen} />
            <Stack.Screen name="LobbyPromohub" component={PromoHubStack} />
        </Stack.Navigator>
    );
};
